export default __webpack_public_path__ + "static/media/company.4d1a775d.svg";